<angular-tag-cloud
  [data]="series"
  [height]="chartOptions?.height"
  [width]="chartOptions?.width"
  [overflow]="chartOptions?.overflow"
  [zoomOnHover]="chartOptions?.zoomOnHover"
  [font]="chartOptions?.font"
>
</angular-tag-cloud>
